export const selectIsLoggedIn = ({ user }) =>
  !!(user?.base?.id && user?.base?.email);
export const selectUser = ({ user }) => user?.base ?? {};
export const selectLoggedInUserId = ({ user }) => user?.base?.id ?? '';
export const selectUserIsAdmin = ({ user }) => user?.base?.isAdmin ?? false;
